import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Unstable_Grid2";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import TableHeader from "components/Table/TableHeader";
import TableElement from "components/Table/TableElement";
import { NotificationTopicsApi } from "apis/NotificationTopicsApi";
import { GroupsApi } from "apis/GroupsApi";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useMediaQuery } from "@mui/material";
import MatAutoComplete from "components/MatAutoComplete/MatAutoComplete";
import CircularIndeterminateModal from "../../utils/Loading";
import { useDispatch, useSelector } from "react-redux";
import { setLoadingPanel } from "../../redux/features/loading";
import { ActionButton, TableCard, FormCard, EditButton } from "utils/ui";

const NotificationTopics = () => {
  const navigate = useNavigate();
  const [notification, setNotification] = useState([]);
  const [groups, setGroups] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loadingReducer.isLoading);
  const [isEdit, setIsEdit] = useState(false);
  const [formData, setFormData] = useState({
    name: null,
    description: null,
    isActive: null,
    isDeleted: null,
    groups: [],
  });
  const [open, setOpen] = useState(false);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const getNotification = () => {
    dispatch(setLoadingPanel(true));
    NotificationTopicsApi.GetNotification()
      .then((res) => {
        setNotification(res.data.data);
        setTotalPages(res.data.pages);
        dispatch(setLoadingPanel(false));
      })
      .catch((err) => {
        dispatch(setLoadingPanel(false));
        if (err?.response?.data) {
          toast(err.response.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
        if (err.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const addNotification = () => {
    NotificationTopicsApi.AddNotification(formData)
      .then((res) => {
        toast("Notification Added", {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        setOpen(false);
        setFormData({
          name: null,
          description: null,
          isActive: null,
          isDeleted: null,
          groups: [],
        });
        getNotification();
      })
      .catch((err) => {
        if (err?.response?.data) {
          toast(err.response.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
        if (err.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const EditNotification = (row) => {
    setIsEdit(true);
    setFormData({
      id: row.id,
      name: row.name,
      description: row.description,
      isActive: row.isActive,
      isDeleted: row.isDeleted,
    });
    setOpen(true);
  };

  const edit = () => {
    NotificationTopicsApi.EditNotification(formData.id, formData)
      .then((res) => {
        toast("Notification Updated", {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        setOpen(false);
        setFormData({
          name: null,
          description: null,
          isActive: null,
          isDeleted: null,
          groups: [],
        });
        getNotification();
      })
      .catch((err) => {
        if (err?.response?.data) {
          toast(err.response.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
        if (err.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({
      name: null,
      description: null,
      isActive: null,
      isDeleted: null,
      groups: [],
    });
    setIsEdit(false);
  };

  const getGroupsData = (keyword) => {
    GroupsApi.GetGroupsListBySearch({
      keyword: keyword,
      page: 0,
      size: 99,
    })
      .then((res) => {
        setGroups(res.data.data);
      })
      .catch((err) => {
        toast(err?.response?.data?.message, {
          type: "error",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        if (err.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const getSelectedGroups = (data) => {
    setFormData({
      ...formData,
      groups: data.map((e) => e.id),
    });
    setGroups(data);
  };

  useEffect(() => {
    getNotification();
  }, []);
  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <>
      <CircularIndeterminateModal open={isLoading && !notification.length} />
      <FormCard>
        <div className="text-right w-full">
          <ActionButton icon="fas fa-plus" onClick={() => setOpen(true)}>
            Add Notification
          </ActionButton>
        </div>
      </FormCard>
      <TableCard>
        <div className="overflow-x-auto">
          <div className="flex justify-center p-4">
            <Pagination
              count={totalPages}
              page={currentPage}
              color="primary"
              onChange={handlePageChange}
              size={isMobile ? "small" : "medium"}
            />
          </div>
          <table className="w-full border-collapse" style={{ minWidth: 600 }}>
            <thead>
              <tr>
                <TableHeader heading="" />
                <TableHeader heading="Name" />
                <TableHeader heading="Description" />
                <TableHeader heading="Active" />
                <TableHeader heading="Deleted" />
                <TableHeader heading="" />
              </tr>
            </thead>
            <tbody>
              {notification?.map((n, i) => {
                return (
                  <tr
                    key={i}
                    style={{ transition:"background 100ms" }} onMouseEnter={(e)=>e.currentTarget.style.background="#F8FAFC"} onMouseLeave={(e)=>e.currentTarget.style.background="transparent"}
                  >
                    <TableElement value={i + 1} />
                    <TableElement value={n.name} />
                    <TableElement value={n.description} />
                    <TableElement value={n.isActive} type="boolean" />
                    <TableElement value={n.isDeleted} type="boolean" />
                    <TableElement
                      value={
                        <EditButton onClick={() => EditNotification(n)} />
                      }
                      type="element"
                    />
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </TableCard>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {!isEdit
            ? "Add Notification"
            : `Edit Notification - ${formData.name}`}
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12} md={6}>
              <TextField
                id="standard-basic"
                sx={{ m: 2 }}
                label="Name"
                name="name"
                variant="standard"
                value={formData.name}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    name: e.target.value,
                  });
                }}
              />

              <TextField
                id="standard-basic"
                sx={{ m: 2 }}
                label="Description"
                name="description"
                variant="standard"
                multiline
                value={formData.description}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    description: e.target.value,
                  });
                }}
              />

              <div className="mx-4 mt-7">
                <MatAutoComplete
                  label={"Search by Group name"}
                  getData={getGroupsData}
                  options={groups}
                  setOptions={setGroups}
                  setValue={getSelectedGroups}
                  isMultiple={true}
                />
              </div>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl sx={{ m: 2 }}>
                <FormLabel id="demo-controlled-radio-buttons-group">
                  Active
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group"
                  name="isActive"
                  value={formData.isActive}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      isActive: e.target.value,
                    });
                  }}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="True"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="False"
                  />
                </RadioGroup>
              </FormControl>

              <FormControl sx={{ m: 2 }}>
                <FormLabel id="demo-controlled-radio-buttons-group">
                  Deleted
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group"
                  name="isDeleted"
                  value={formData.isDeleted}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      isDeleted: e.target.value,
                    });
                  }}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="True"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="False"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {isEdit ? (
            <Button onClick={edit}>Save Changes</Button>
          ) : (
            <Button onClick={addNotification}>Save</Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NotificationTopics;
